import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { treatmentExerciseService } from 'services/treatmentExerciseService';
import { PrescribeExerciseDto, UpdateExerciseDosageDto } from 'types/models';

const KEY = 'treatment-exercises';

export function useTreatmentExercises(planId: string | null) {
  return useQuery({
    queryKey: [KEY, planId],
    queryFn: () => treatmentExerciseService.list(planId!),
    enabled: !!planId,
  });
}

export function usePrescribeExercise() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ planId, payload }: { planId: string; payload: PrescribeExerciseDto }) =>
      treatmentExerciseService.prescribe(planId, payload),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: [KEY, vars.planId] });
    },
  });
}

export function useUpdateExerciseDosage() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ planId, exerciseId, payload }: { planId: string; exerciseId: string; payload: UpdateExerciseDosageDto }) =>
      treatmentExerciseService.update(planId, exerciseId, payload),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: [KEY, vars.planId] });
    },
  });
}

export function useRemoveExercise() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ planId, exerciseId }: { planId: string; exerciseId: string }) =>
      treatmentExerciseService.remove(planId, exerciseId),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: [KEY, vars.planId] });
    },
  });
}
